

export default {
    data() {
        return {
            tableList: [],
            isDetailDialogShow: false,
            selectedItem: {},
            product: {},
            file: '',
        };
    },
    methods: {
        cusViewOrderBillTable() {
            this.$http.cusViewOrderBillTable(null,null,null,null,null,null,this.$store.state.currentUser.id).then(res => {
                if (res.code === 200) {
                    this.tableList = res.data;
                }
            })
        },
        showDetail(row) {
            this.selectedItem = row;
            this.isDetailDialogShow = true;
            this.viewProjectInfo(row.productId);
        },
        beforeCoverPicUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 10;
            if (!isLt2M) {
                this.$message.error("上传大小不能超过 10MB!");
            }
            return isLt2M;
        },

        onCoverPicUpload(e) {
            let file = e.file;
            console.log(file);
            this.$http.uploadFile(file,file.name).then(res => {
                if (res.code === 200) {
                    this.file = res.data;
                    this.$forceUpdate();
                }
            })
        },
        submitHetong() {
            if (this.$verify.checkIfNull(this.file)) {
                this.$myAnime.shakeElement('.file-uploader');
                this.$hint.message.info('请上传已签字的合同附件');
                return;
            }

            let obj = {
                id: this.selectedItem.id,
                hetongfujian: this.file
            }

            this.$http.updateOrderBill(obj).then(res => {
                if (res.code === 200) {
                    this.isDetailDialogShow = false;
                }
            })
        },
        viewProjectInfo(id) {
            this.$http.viewProductById(id).then(res => {
                this.product = res.data;
            })
        }
    },
    created() {
        this.cusViewOrderBillTable();
    }
}